/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import proptypes from 'prop-types';
const { shape, string, arrayOf, func, bool } = proptypes;
import classNames from 'classnames';
import {
  TileContent,
  TileMedia,
  TileText,
  Tile
} from '@one-thd/sui-atomic-components';
import { noop } from '../../utils/utils';

const CategoryTab = ({ isSelected, category, onClick }) => {

  const buttonClass = classNames(
    'sui-flex sui-border-solid sui-rounded-base sui-p-2 sui-w-[224px] sui-h-[50px] sui-justify-between', {
      'sui-border-primary sui-border-1': !isSelected,
      'sui-border-[#F96302] sui-border-2': isSelected,
    }
  );

  const textWarperClass = classNames(
    'sui-flex sui-text-sm', {
      'sui-text-primary sui-font-bold': isSelected,
      'sui-text-info': !isSelected,
    }
  );

  const textClass = (textLength) => classNames(
    'sui-pl-1 sui-w-36 sui-line-clamp-2', {
      'sui-py-2': textLength < 21
    }
  );

  return (
    <Tile
      onClick={onClick}
      variant={isSelected ? 'secondary' : 'text'}
      value={category.name}
      aria-label={category.name}
      selected={isSelected}
      className={buttonClass}
    >
      <TileContent>
        <TileMedia
          component="img"
          className="sui-w-[30px] sui-h-[30px]"
          src={category.image.url}
          alt={`${category.name} product image`}
          loading="lazy"
        />
        <TileText>
          <div className={textWarperClass}>
            <div className={textClass(category.name.length)}>
              {category.name}
            </div>
            <div className="sui-py-2">
              ({category.itemIds.length})
            </div>
          </div>
        </TileText>
      </TileContent>
    </Tile>
  );
};

CategoryTab.displayName = 'CategoryTab';

CategoryTab.propTypes = {
  isSelected: bool,
  category: shape({
    name: string.isRequired,
    itemIds: arrayOf(string.isRequired).isRequired,
    categoryId: string.isRequired,
    image: shape({
      url: string.isRequired
    }).isRequired
  }).isRequired,
  onClick: func,
};

CategoryTab.defaultProps = {
  isSelected: false,
  onClick: noop,
};

export { CategoryTab };
